/* import __COLOCATED_TEMPLATE__ from './security.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();